'use strict';

var GlobalNotifConstants = {
  GLOBAL_NOTIF_TABS: {
    GLOBAL: 'globalTab',
    CATEGORY2: 'category2Tab'
  },
  GLOBAL_NOTIF_PANEL_TITLE_PREFIX: {
    GLOBAL: 'Global',
    CATEGORY2: 'Category 2'
  }
};
module.exports = GlobalNotifConstants;